import React from "react";
import { motion } from "framer-motion";
import Person1 from "../../assets/images/sedrak-full.jpg";
import Person2 from "../../assets/images/kenny-full.jpg";
import Person3 from "../../assets/images/ryan-full.jpg";

const ThankYouPage = () => {
  return (
    <div className="bg-white p-8 md:p-10 rounded-lg shadow-[0_0_20px_rgba(0,0,0,0.1)] border-2 border-gray-200 w-full max-w-5xl font-inter mx-auto flex flex-col">
      {/* First section: Heading and intro text */}
      <div>
        <motion.div
          className="relative mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-[#5379F6] text-left mb-2 relative z-10"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 10,
              delay: 0.2,
            }}
          >
            You're In! 🎉
          </motion.h2>
          <motion.div
            className="absolute -bottom-2 left-0 h-4 bg-yellow-300 w-48 md:w-64 z-0 rounded-full opacity-70"
            initial={{ width: 0 }}
            animate={{ width: "12rem" }}
            transition={{ duration: 0.7, delay: 0.6 }}
          />
        </motion.div>
        <p className="text-lg font-medium text-[#5C5C5C] text-left mb-4">
          Thank you for joining the Scholarty wait-list
        </p>
        <p className="text-lg font-medium text-[#4A4A4A] text-left mb-6">
          You're now part of a growing movement to reimagine how students
          connect, collaborate, and lead across campuses
        </p>
      </div>

      {/* Second section: 50/50 split */}
      <div className="flex flex-col md:flex-row w-full gap-8 mb-6">
        {/* Left side: More text or call to action */}
        <div className="flex-1 flex flex-col justify-center">
          <h3 className="text-3xl font-bold text-black text-left mb-4">
            Note from the Founders
          </h3>
          <p className="text-lg font-medium text-[#4A4A4A] text-left">
            We are building Scholarty because we believe student leadership,
            innovation, and community should never be limited by the walls of
            one campus. Whether you're in high school or college, there's so
            much potential when we bridge those silos and build something bigger
            together.
          </p>
        </div>
        {/* Right side: Images with names */}
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="flex flex-row justify-between w-full gap-x-2">
            {/* Person 1 */}
            <div className="flex flex-col items-center flex-1">
              <img
                src={Person1}
                alt="Sedrak Vardanyan"
                className="w-32 h-32 object-cover mb-2 mx-auto rounded-full"
              />
              <span className="text-sm font-medium text-[#5379F6] text-center ">
                Sedrak Vardanyan
              </span>
            </div>
            {/* Person 2 */}
            <div className="flex flex-col items-center flex-1">
              <img
                src={Person2}
                alt="Kenny Huang"
                className="w-32 h-32 object-cover mb-2 mx-auto rounded-full"
              />
              <span className="text-sm font-medium text-[#5379F6] text-center">
                Kenny Huang
              </span>
            </div>
            {/* Person 3 */}
            <div className="flex flex-col items-center flex-1">
              <img
                src={Person3}
                alt="Ryan Lin"
                className="w-32 h-32 object-cover mb-2 mx-auto rounded-full"
              />
              <span className="text-sm font-medium text-[#5379F6] text-center">
                Ryan Lin
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Third section: Thank you message */}
      <p className="text-lg font-medium text-[#4A4A4A] text-left">
        We're thrilled you're here early. As a wait-list member, you’ll get
        exclusive first access, behind-the-scenes updates, and the chance to
        shape the future of campus engagement with us.
      </p>
    </div>
  );
};

export default ThankYouPage;
